
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  id: '4a36f66249',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page coupon-page" data-name="myCoupon" id="myCouponList">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">My Coupons</div>\n            </div>\n        </div>\n        <div class="page-content">\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.length, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="coupon-intro">\n                <div class="coupon-intro-title">Active coupons</div>\n                <div class="coupon-intro-sub">Tap a code to copy and use it at checkout.</div>\n            </div>\n            <div class="coupon-list">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <div class="coupon-card">\n                    <div class="coupon-card-stub">\n                        <i class="icon f7-icons if-not-md">tag_fill</i>\n                        <i class="icon material-icons md-only">local_offer</i>\n                    </div>\n                    <div class="coupon-card-body">\n                        <div class="coupon-card-code couponCode">';
              r += c(ctx_3.code, ctx_3);
              r += '</div>\n                        <div class="coupon-card-desc">';
              r += c(ctx_3.description, ctx_3);
              r += '</div>\n                    </div>\n                    <button class="coupon-card-copy couponApply copyCoupun" data-code="';
              r += c(ctx_3.code, ctx_3);
              r += '">\n                        <i class="icon f7-icons if-not-md">doc_on_doc_fill</i>\n                        <i class="icon material-icons md-only">content_copy</i>\n                        <span>Copy</span>\n                    </button>\n                </div>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <img src="static/img/no_coupon.svg" alt="">\n                <div class="empty-state-title">No coupons available</div>\n                <div class="empty-state-sub">Check back later \u2014 fresh offers are added regularly.</div>\n            </div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    